/**
 * scroll page to top
 */
export const scrollToTop = () => {
  window.scrollTo(0, 0);
};

/**
 * redirect window url
 * @param {*} path
 */
export const redirectToPath = (path: string) => {
  window.location.replace(path);
  // TODO: look up assign vs replace. replace may not work well with back button
  // this function is necessary due to react-router not encoding %25 in the signin route properly
  // window.location.assign(path);
};

/**
 * parses and returns url parameters
 * i.e. getUrlVars()["x"];
 */
export const getUrlVars = () => {
  const vars = {};
  window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    (m: any, key: any, value: any) => {
      vars[key] = value;
    }
  );
  return vars;
};

export const hostName = () => window.location.hostname;

export const isFeatureSwitchOn = (key: string) =>
  (window &&
    window.THD_ACCOUNT_GLOBAL &&
    window.THD_ACCOUNT_GLOBAL.featureSwitches[key] === 1) ||
  false;

export const handleLiveChat = () => {
  if (
    window.lpTag &&
    window.lpTag.taglets &&
    window.lpTag.taglets.rendererStub
  ) {
    window.lpTag.taglets.rendererStub.click(186822814, {
      preChatLines: [''],
    });
  }
};

export const getCmMmcQueryString = () => {
  const queryString = getUrlVars();
  return queryString.cm_mmc ? `cm_mmc=${queryString.cm_mmc}` : '';
};

/**
 * get path name
 */
export const getPathName = () => window.location.pathname;


